function pad(value) {
  return String(value).padStart(2, "0")
}

function renderCountdown(element, target) {
  const diff = target - Date.now()

  if (diff <= 0) {
    element.textContent = element.dataset.saleCountdownEnded || ""
    return false
  }

  const totalMinutes = Math.floor(diff / 1000 / 60)
  const days = Math.floor(totalMinutes / 60 / 24)
  const hours = Math.floor((totalMinutes / 60) % 24)
  const minutes = totalMinutes % 60

  element.textContent = `${days} d : ${pad(hours)} h : ${pad(minutes)} m`
  return true
}

function initCountdown(element) {
  const target = Number(element.dataset.saleCountdownTarget)
  if (!target) {
    return
  }

  renderCountdown(element, target)

  const interval = setInterval(() => {
    if (!renderCountdown(element, target)) {
      clearInterval(interval)
    }
  }, 1000)
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll("[data-sale-countdown-target]")
    .forEach(initCountdown)
})
